import { agentWhatsAppHref as buildAgentWhatsAppHref } from '../api/agentContact';

/** Mock-only fixture. No network. Numbers and names match the artifact verbatim. */

export const PORTAL_FIXTURE = {
  firstName: 'María',
  lastName: 'González',
  fullName: 'María González',
  applicationNumber: 'OL-2481-XT',
  startedOn: '24 de agosto de 2026',
  product: 'Vida a término, 20 años',
  coverage: '$500,000',
  termYears: '20 años',
  premium: '$47.20',
  premiumMonthly: '$47.20 / mes',
  offerPremium: '$54.28',
  offerPremiumMonthly: '$54.28 / mes',
  offerCoverage: '$410,000',
  beneficiaries: '1 designado',
  emailMasked: 'm•••a@gmail.com',
  phoneMasked: '••• ••• 4821',
  supportEmail: 'support@olelife.com',
  agent: {
    initials: 'DR',
    name: 'Daniel Ruiz',
    firstName: 'Daniel',
    role: 'Tu agente con licencia · Habla español',
    speaks: 'Habla español',
    email: 'daniel.ruiz@olelife.com',
    tel: '15555554821',
    waNumber: '15555554821',
  },
  dates: {
    sent: '24 de agosto',
    incomeReceived: '25 de agosto',
    requirementsComplete: '26 de agosto',
    assigned: '27 de agosto',
    decisionEta: '11 de septiembre',
    initialDeadline: '23 de septiembre',
    uwDeadline: '29 de septiembre',
    offerExpires: '11 de septiembre',
    activeSince: '2 de septiembre de 2026',
    nextDebit: '2 de octubre',
    cancelledOn: '23 de septiembre',
    labExam: '12 de agosto',
  },
  recoverSubject: 'Solicitud OL-2481-XT — no puedo entrar al portal',
} as const;

export function agentMailto(subject = PORTAL_FIXTURE.recoverSubject): string {
  return `mailto:${PORTAL_FIXTURE.agent.email}?subject=${encodeURIComponent(subject)}`;
}

export function supportMailto(subject = PORTAL_FIXTURE.recoverSubject): string {
  return `mailto:${PORTAL_FIXTURE.supportEmail}?subject=${encodeURIComponent(subject)}`;
}

/** Thin fixture wrapper — distinct from api/agentContact.agentWhatsAppHref. */
export function fixtureAgentWhatsAppHref(text = PORTAL_FIXTURE.recoverSubject): string {
  return buildAgentWhatsAppHref(PORTAL_FIXTURE.agent.waNumber, text) || `#`;
}

export function agentTelHref(): string {
  return `tel:${PORTAL_FIXTURE.agent.tel}`;
}
